import { Button, Callout, Modal } from '@dev-spendesk/grapes';
import React from 'react';

import { useTranslation } from 'common/hooks/useTranslation';
import handHoldingPhone from 'modules/StrongCustomerAuthentication/images/hand-holding-phone.png';

import './ScaWireTransferConfirmationModal.css';

interface Props {
  isOpen: boolean;
  onUseAlternateMethod: () => void;
  onClose: () => void;
  isScaNotWorking?: boolean;
}

export const ScaWireTransferConfirmationModal = ({
  isOpen,
  onUseAlternateMethod,
  onClose,
  isScaNotWorking,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      isOpen={isOpen}
      iconName="lock-close"
      iconVariant="info"
      title={t('wiretransfer.modal.sca.confirmWireTransfer.title')}
      subtitle={t('wiretransfer.modal.sca.confirmWireTransfer.desc')}
      actions={[
        <Button
          key="cancel"
          text={t('wiretransfer.modal.sca.confirmWireTransfer.cancel')}
          variant="secondaryNeutral"
          onClick={onClose}
        />,
        ...(isScaNotWorking
          ? [
              <Button
                key="alternate"
                text="Use alternate flow"
                variant="tertiaryBrand"
                onClick={onUseAlternateMethod}
              />,
            ]
          : []),
      ]}
    >
      <div className="ScaWireTransferConfirmationModal__content">
        <div className="ScaWireTransferConfirmationModal__img__background">
          <img
            className="ScaWireTransferConfirmationModal__img"
            src={handHoldingPhone}
            alt="Hand holding a phone"
          />
        </div>
        <div className="ScaWireTransferConfirmationModalTitle">
          {t(
            'wiretransfer.modal.sca.confirmWireTransfer.authenticateMobileMessage',
          )}
        </div>
        {isScaNotWorking ? (
          <Callout
            title={t(
              'wiretransfer.modal.sca.confirmWireTransfer.scaNotWorkingTitle',
            )}
            variant="alert"
          />
        ) : null}
      </div>
    </Modal>
  );
};
